const KLAVIYO_SUBSCRIBE_SRC =
  "https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js";

let klaviyoSubscribeRequest = null;

const loadKlaviyoSubscribe = () => {
  if (typeof KlaviyoSubscribe !== "undefined") return Promise.resolve();
  if (klaviyoSubscribeRequest) return klaviyoSubscribeRequest;

  klaviyoSubscribeRequest = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = KLAVIYO_SUBSCRIBE_SRC;
    script.addEventListener("load", resolve);
    script.addEventListener("error", reject);
    document.head.appendChild(script);
  });

  return klaviyoSubscribeRequest;
};

class KlaviyoForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form) return;

    this.errorLabel = this.querySelector(".cta-input__label-error");
    this.defaultError = this.errorLabel ? this.errorLabel.textContent.trim() : "";

    this.form.email.addEventListener("input", () => this.clearError());
    this.form.addEventListener("submit", (e) => this.validate(e));

    loadKlaviyoSubscribe()
      .then(() => this.attachToKlaviyo())
      .catch(() => {});
  }

  attachToKlaviyo() {
    if (typeof KlaviyoSubscribe === "undefined") return;

    KlaviyoSubscribe.attachToForms(this.form, {
      hide_form_on_success: true,
      success: ($form) => $form.addClass("success"),
      extra_properties: {
        $source: "Shopify Form",
        $method_type: "Custom Klaviyo Form",
      },
    });

    this.watchServerErrors();
  }

  watchServerErrors() {
    const source = this.form.querySelector(".error_message");

    if (!source) return;

    new MutationObserver(() => {
      const message = source.textContent.trim();

      if (message) this.setError(message);
    }).observe(source, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  setError(message) {
    if (this.errorLabel && message) this.errorLabel.textContent = message;

    this.form.email.setAttribute("aria-invalid", "true");
    this.form.email
      .closest(".cta-input__input-wrapper")
      .classList.add("error");
  }

  validate(event) {
    if (KlaviyoForm.isValidEmail(this.form.email.value)) {
      this.clearError();
      return;
    }

    event.preventDefault();
    this.setError(this.defaultError);
    this.form.email.focus();
  }

  clearError() {
    if (this.errorLabel) this.errorLabel.textContent = this.defaultError;

    this.form.email.setAttribute("aria-invalid", "false");
    this.form.email
      .closest(".cta-input__input-wrapper")
      .classList.remove("error");
  }

  static isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
